module.exports = __webpack_public_path__ + "static/media/auth-bg-big.34f9eeef.jpg";